import { Button } from '../ui/button';
import { ArrowRight, Mail, Linkedin, Calendar, MapPin, Clock } from 'lucide-react';

export const ContactCTASection = () => {
  const bestFor = [
    'CIOs/CTOs planning cloud or AI transformations',
    'Infrastructure leaders seeking cost optimization',
    'Organizations deploying multi-model LLM architectures',
    'Teams needing DevSecOps or SRE expertise',
  ];

  return (
    <section className="py-20 md:py-32 bg-white" data-testid="contact-cta-section">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
          {/* Content */}
          <div className="space-y-6">
            <div className="space-y-4">
              <p className="text-[#3498DB] font-semibold tracking-[0.2em] uppercase text-sm">
                Get in Touch
              </p>
              <h2 className="font-['Montserrat'] font-bold text-3xl md:text-4xl text-[#2C3E50]">
                Let's Talk
              </h2>
            </div>

            <p className="text-[#64748B] text-lg leading-relaxed">
              Interested in working together? I'd love to hear about your infrastructure challenges.
            </p>

            <div className="space-y-4">
              <p className="text-[#2C3E50] font-semibold">Best for:</p>
              <ul className="space-y-3">
                {bestFor.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <span className="text-[#3498DB] mt-1">•</span>
                    <span className="text-[#64748B]">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <Button
              asChild
              className="bg-[#3498DB] hover:bg-[#2980B9] text-white px-8 py-6 text-base shadow-[0_4px_14px_0_rgba(52,152,219,0.39)]"
              data-testid="contact-cta-button"
            >
              <a href="https://calendly.com/siddharthkaul" target="_blank" rel="noopener noreferrer">
                <Calendar size={18} className="mr-2" />
                Book 30-min Consultation
              </a>
            </Button>
          </div>

          {/* Contact Options */}
          <div className="space-y-6">
            <div className="bg-[#F8F9FA] rounded-xl p-6 space-y-4">
              <h3 className="font-['Montserrat'] font-semibold text-lg text-[#2C3E50]">
                Contact Options
              </h3>
              
              <div className="space-y-4">
                <a
                  href="mailto:sidd@siddharthkaul.com"
                  className="flex items-center gap-4 p-4 bg-white rounded-lg border border-slate-200 hover:border-[#3498DB] transition-colors duration-200"
                  data-testid="contact-email-option"
                >
                  <div className="w-10 h-10 rounded-lg bg-[#3498DB]/10 flex items-center justify-center">
                    <Mail className="text-[#3498DB]" size={20} />
                  </div>
                  <div>
                    <p className="font-medium text-[#2C3E50]">Email</p>
                    <p className="text-sm text-[#64748B]">sidd@siddharthkaul.com</p>
                  </div>
                </a>

                <a
                  href="https://linkedin.com/in/siddharth-k-8b41b619"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-4 p-4 bg-white rounded-lg border border-slate-200 hover:border-[#3498DB] transition-colors duration-200"
                  data-testid="contact-linkedin-option"
                >
                  <div className="w-10 h-10 rounded-lg bg-[#3498DB]/10 flex items-center justify-center">
                    <Linkedin className="text-[#3498DB]" size={20} />
                  </div>
                  <div>
                    <p className="font-medium text-[#2C3E50]">LinkedIn</p>
                    <p className="text-sm text-[#64748B]">linkedin.com/in/siddharth-k-8b41b619</p>
                  </div>
                </a>
              </div>
            </div>

            <div className="bg-[#2C3E50] rounded-xl p-6 text-white">
              <div className="flex items-center gap-3 mb-4">
                <Clock className="text-[#3498DB]" size={20} />
                <h3 className="font-['Montserrat'] font-semibold">Response Time</h3>
              </div>
              <ul className="space-y-2 text-slate-300 text-sm">
                <li>Consulting inquiries: 24-48 hours</li>
                <li>Speaking requests: 1 week</li>
                <li>General questions: 2-3 days</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
